import { i18n } from "@/i18n";

/**
 * Verifies the authenticity of an email string
 * @param {*} value string that contains the email to be validated
 */

export const emailValid = (value: string) =>
  // eslint-disable-next-line
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  ) || `${i18n.global.t("validatorService.invalidEmail")}`;

/**
 * Limits the minimum length of a string to a certain number of characters
 * @param {*} min minimum number of characters in the string
 */
export const minLength = (value: string, min: number) =>
  value.length >= min ||
  `${i18n.global.t("validatorService.minLength")} ${min}`;

/**
 * Limits the maximum length of a string to a certain number of characters
 * @param {*} max maximum number of characters in the string
 */
export const maxLength = (max: number) => (value: string) =>
  value.length <= max ||
  `${i18n.global.t("validatorService.maxLength")} ${max}`;

/**
 * Validates a model field as a required field
 * @param {*} v if the string of the model where this rule is applied doesn't have any value, shows an error message in the input field.
 */
export const required = (v: any) =>
  !!v || `${i18n.global.t("validatorService.required")}`;

/**
 * Validates a model field as a required field of ELEMENT Framework
 * @param {*} v if the string of the model where this rule is applied doesn't have any value, shows an error message in the input field.
 */
export const requiredElement = {
  required: true,
  message: i18n.global.t("validatorService.required"),
  trigger: "blur",
};

/**
 * Verifies the authenticity of an email string
 * @param {*} value string that contains the email to be validated
 */
export const emailValidElement = {
  type: "email",
  message: i18n.global.t("validatorService.invalidEmail"),
  trigger: ["blur", "change"],
};

/**
 * Limits the maximum length of a string to a certain number of characters
 * @param {*} max maximum number of characters in the string
 */
export const maxLengthElement = (max: number): any => ({
  max,
  message: i18n.global.t("validatorService.maxLength"),
  trigger: ["blur"],
});

/**
 * Limits the minimum length of a string to a certain number of characters
 * @param {*} min minimum number of characters in the string
 */
export const minLengthElement = (min: number): any => ({
  min,
  message: i18n.global.t("validatorService.maxLength"),
  trigger: ["blur"],
});
